export const CloudConnectState = [
  {
    Name: 'Connecting',
    Value: false,
    Id: 0,
    Color: '#f5ff62',
    LblClass: 'lbl-connecting',
    ForeColor: 'Black'
  },
  {
    Name: 'Connected',
    Value: false,
    Id: 1,
    Color: '#ffb122fc',
    LblClass: 'lbl-connected',
    ForeColor: 'Black'
  },
  {
    Name: 'Error',
    Value: false,
    Id: 2,
    Color: '#ec2d2dfc',
    LblClass: 'lbl-error',
    ForeColor: 'White'
  }
];

// export const CloudDetail = [
//   {
//     Id: '5f3ea3d59961931598516b3f',
//     CollectionEntryId: '5e936131d197c66664251ffa',
//     key: 'AWS',
//     Name: 'AWS',
//     Description: 'Amazon Web Services',
//     ImagePath: 'assets/img/demo/aws-logo.png',
//     Class: 'lbl-aws'
//   },
//   {
//     Id: '5f3eaa989961931598517327',
//     CollectionEntryId: '5f356dd41106881d181e7980',
//     key: 'Azure',
//     Name: 'Azure',
//     Description: 'Microsoft Azure',
//     ImagePath: 'assets/img/demo/azure-icon.png',
//     Class: 'lbl-azure'
//   },
//   {
//     Id: '5f6a57970c5d669af6e790b6',
//     CollectionEntryId: '5edcd7c8514bbf387c49746d',
//     key: 'GCP',
//     Name: 'GCP',
//     Description: 'Google Cloud Platform',
//     ImagePath: 'assets/img/demo/gcp-icon.png',
//     Class: 'lbl-gcp'
//   },
//   {
//     Id: '65ef21175454efa6e38f3e6b',
//     CollectionEntryId: '65eb2b95d77034a8d6a26e7f',
//     key: 'PAN-OS',
//     Name: 'PAN-OS',
//     Description: 'Palo Alto Networks',
//     ImagePath: 'assets/img/demo/panw-icon.png',
//     Class: 'lbl-gcp'
//   },
//   {
//     Id: '65fb19a6ad7962b528c0b3c2',
//     CollectionEntryId: '65fb17b69e1c32ad096c64f2',
//     key: 'DC Automation',
//     Name: 'DC Automation',
//     Description: 'Allows you to manage a range of devices in DC',
//     ImagePath: 'assets/img/demo/dc-automation-icon.png',
//     Class: 'lbl-gcp'
//   },
//   {
//     Id: '6638e15a356e1235d1afecd6',
//     CollectionEntryId: '66389da16746d169fb0dba19',
//     key: 'OCI',
//     Name: 'OCI',
//     Description: 'Oracle Cloud Infrastructure.',
//     ImagePath: 'https://i.imgur.com/C0n5Oal.png',
//     Class: 'lbl-gcp'
//   },
//   {
//     Id: '66a8275ebd7e99fef0bc028a',
//     CollectionEntryId: '66a3d2220929af02b9a6fb8c',
//     key: 'VMware vSphere',
//     Name: 'VMware vSphere',
//     Description: 'VMware vSphere',
//     ImagePath: 'https://imgur.com/v1Z8meL.png',
//     Class: 'lbl-gcp'
//   }
// ];

export const ClaimProgressState = [
  { Name: 'Pending', Value: 'Pending', Id: 0, Color: '#FFC107', ForeColor: 'Black' },
  { Name: 'InProcess', Value: 'In Process', Id: 1, Color: '#22ccff', ForeColor: 'white' },
  { Name: 'Error', Value: 'Error', Id: 2, Color: '#ec2d2dfc', ForeColor: 'White' },
  { Name: 'Success', Value: 'Success', Id: 3, Color: '#4CAF50', ForeColor: 'White' }
];

export const SyncState = [
  {
    Value: 'Import In Progress',
    Name: 'ImportInProgress',
    Id: 0,
    Color: 'blue',
    LblClass: 'lbl-connected',
    ForeColor: 'white'
  },
  {
    Value: 'Imported',
    Name: 'Imported',
    Id: 1,
    Color: '#4caf50',
    LblClass: 'lbl-error',
    ForeColor: 'White'
  }
];

export const DirectoryState = [
  { Name: 'Connecting', Value: 'Pending', Id: 0, Color: '#FFC107', ForeColor: 'Black' }, // Amber
  { Name: 'Connected', Value: 'Resolved', Id: 1, Color: '#4CAF50', ForeColor: 'White' }, // Green
  { Name: 'Error', Value: 'Suppressed', Id: 2, Color: '#ec2d2dfc', ForeColor: 'White' }
];

export const DeviceConnectivityStatus = [
  {
    Name: 'Connecting',
    Value: 'Connecting',
    Id: 0,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Connected',
    Value: 'Connected',
    Id: 1,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },
  {
    Name: 'ConnectionFailed',
    Value: 'Connection Failed',
    Id: 2,
    Color: '#ec2d2dfc',
    LblClass: 'lbl-error',
    ForeColor: 'White'
  }
];

export const ConfigurationState = [
  {
    Name: 'NotInitalized',
    Value: 'Not Initalized',
    Id: 0,
    Color: '#22ffd6',
    LblClass: 'lbl-running',
    ForeColor: '#000000'
  },
  {
    Name: 'SyncInQueue',
    Value: 'Sync in Queue',
    Id: 1,
    Color: '#ffc107',
    LblClass: 'lbl-pending-approval',
    ForeColor: '#000000'
  },
  {
    Name: 'SyncInProgress',
    Value: 'Sync in Progress',
    Id: 2,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff'
  },
  {
    Name: 'ParsingInQueue',
    Value: 'Parsing in Queue',
    Id: 3,
    Color: '#ffc107',
    LblClass: 'lbl-pending-approval',
    ForeColor: '#000000'
  },
  {
    Name: 'ParsingInProgress',
    Value: 'Parsing in Progress',
    Id: 4,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Healthy',
    Value: 'Healthy',
    Id: 5,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },
  {
    Name: 'DriftDetected',
    Value: 'Drift Detected',
    Id: 6,
    Color: '#ec2d2d',
    LblClass: 'lbl-delete',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Error',
    Value: 'Error',
    Id: 7,
    Color: '#ec2d2d',
    LblClass: 'lbl-delete',
    ForeColor: '#ffffff'
  },
  {
    Name: 'ModelNotDefined',
    Value: 'Config Pulled - Model Not Defined',
    Id: 8,
    Color: '#ffc107',
    LblClass: 'lbl-pending-approval',
    ForeColor: '#000000'
  }
];

export const DeviceState = [
  {
    Name: 'Healthy',
    Value: 'Healthy',
    Id: 0,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },

  {
    Name: 'Unhealthy',
    Value: 'Unhealthy',
    Id: 1,
    Color: '#ec2d2d',
    LblClass: 'lbl-delete',
    ForeColor: '#ffffff'
  },
  {
    Name: 'NoStateRuleDefined',
    Value: 'No State Rule Defined',
    Id: 2,
    Color: '#ffc107',
    LblClass: 'lbl-pending-approval',
    ForeColor: '#000000'
  }
];

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CloudConnectStateService {
  CloudData: any = [];
  constructor() {}

  getState(Id: number) {
    return CloudConnectState.find((d) => d.Id === Id);
  }

  getDirectoryState(Id: number) {
    return DirectoryState.find((d) => d.Id === Id);
  }

  getSyncState(Id: number) {
    return SyncState.find((d) => d.Id === Id);
  }

  getCloudCollectionEntryId(Id: number) {
    return this.CloudData.find((d) => d.CollectionEntry.Id == Id?.toString());
  }

  getCloud(Key: string) {
    return this.CloudData.find((d) => d.Name.toLowerCase() == Key?.toLowerCase());
  }

  getCloudById(Id: number) {
    return this.CloudData.find((d) => d.Id == Id?.toString());
  }

  getClaimState(id: any) {
    return ClaimProgressState.find((d) => d.Id == id);
  }

  getDeviceConnectivityStatus(Id: number) {
    return DeviceConnectivityStatus.find((d) => d.Id === Id);
  }

  getConfigurationState(Id: number) {
    return ConfigurationState.find((d) => d.Id === Id);
  }

  getDeviceState(Id?: number) {
    if (Id === 0 || Id === 1) {
      return DeviceState.find((d) => d.Id === Id);
    }
    return DeviceState.find((d) => d.Id === 2);
  }

  environmentUseInDevice(cloudName) {
    let clouds = ['Cisco IOS-XE', 'NX-OS'];
    return clouds.findIndex((name) => name == cloudName) != -1;
  }

  getExecutionEngine(cloudName) {
    return this.CloudData.find((x) => x.Name == cloudName)?.ExecutionEngine;
  }

  getEnvironmentType(cloudName) {
    return this.CloudData.find((x) => x.Name == cloudName)?.EnvironmentType;
  }

  getCredentialReferenceType(cloudName) {
    return this.CloudData.find((x) => x.Name == cloudName)?.CredentialReferenceType;
  }

  getProviderStyle() {
    return {
      'VMware vSphere': 'lbl-VMware-vSphere',
      'PAN-OS': 'lbl-PAN-OS',
      'Cisco NX-OS': 'lbl-Cisco-NX-OS',
      'Cisco ISE': 'lbl-Cisco-ISE',
      CCC: 'lbl-CCC',
      'NX-OS': 'lbl-NX-OS',
      OCI: 'lbl-oci',
      GCP: 'lbl-gcp',
      AWS: 'lbl-aws',
      'Cisco IOS-XE': 'lbl-Cisco-IOS-XE',
      FMC: 'lbl-FMC',
      Azure: 'lbl-azure',
      'DC Automation': 'lbl-DC-Automation',
      IaC: 'lbl-IaC',
      'DC Auth Profile': 'lbl-DC-Auth-Profile',
      'NX-OS (Terraform)': 'lbl-NX-OS',
      'NX-OS (Ansible)': 'lbl-NX-OS',
      'Nokia SR OS': 'lbl-Nokia-SR-OS',
      Cloudflare: 'lbl-Cloudflare',
      Meraki: 'lbl-Meraki'
    };
  }

  setCloudData(data) {
    this.CloudData = data;
    this.CloudData.forEach((cloud) => {
      if (cloud.CollectionEntry) {
        cloud['CollectionEntryId'] = cloud.CollectionEntry.Id;
        let image = cloud.CollectionEntry.CollectionAttributeValues.find(
          (x) => x.Name.toLowerCase() == 'image'
        );
        if (image) {
          cloud.ImagePath = image.Value;
        }
        let DisplayInModules = cloud.CollectionEntry.CollectionAttributeValues.find(
          (y) => y.Name.trim() == 'DisplayInModules'
        );
        if (DisplayInModules) {
          cloud.DisplayInModule = DisplayInModules.Value.split(',');
        }
        switch (cloud.Name) {
          case 'VMware vSphere':
            cloud.Class = 'lbl-VMware-vSphere';
            break;
          case 'PAN-OS':
            cloud.Class = 'lbl-PAN-OS';
            break;
          case 'Cisco NX-OS':
            cloud.Class = 'lbl-Cisco-NX-OS';
            break;
          case 'Cisco ISE':
            cloud.Class = 'lbl-Cisco-ISE';
            break;
          case 'CCC':
            cloud.Class = 'lbl-CCC';
            break;
          case 'NX-OS':
            cloud.Class = 'lbl-NX-OS';
            break;
          case 'OCI':
            cloud.Class = 'lbl-oci';
            break;
          case 'GCP':
            cloud.Class = 'lbl-gcp';
            break;
          case 'AWS':
            cloud.Class = 'lbl-aws';
            break;
          case 'Cisco IOS-XE':
            cloud.Class = 'lbl-Cisco-IOS-XE';
            break;
          case 'FMC':
            cloud.Class = 'lbl-FMC';
            break;
          case 'Azure':
            cloud.Class = 'lbl-azure';
            break;
          case 'DC Automation':
            cloud.Class = 'lbl-DC-Automation';
            break;
          case 'IaC':
            cloud.Class = 'lbl-IaC';
            break;
          case 'DC Auth Profile':
            cloud.Class = 'lbl-DC-Auth-Profile';
            break;
          default:
            cloud.Class = 'lbl-IaC';
            break;
        }
      }
    });
  }

  filterCloudByPage(pageName) {
    let cloudByPage = [];
    this.CloudData.forEach((cloud) => {
      let clouds = cloud.DisplayInModule?.find((x) => x.toLowerCase() == pageName);
      if (clouds) {
        cloudByPage.push(cloud);
      }
    });
    return cloudByPage;
  }

  getImageByCloudCollectionEntryId(Id: number, defaultImage = '') {
    let image = this.CloudData.find((d) => d.CollectionEntry?.Id == Id?.toString())?.ImagePath;
    if (!image) {
      switch (defaultImage) {
        case 'blueprint':
          image = 'assets/default/default-blueprint.png';
          break;
        default:
          image = 'assets/default/Custom/no-image-available.svg';
          break;
      }
    }
    return image;
  }

  getImageByCloudKey(cloudName: string, defaultImage = '') {
    let image = this.CloudData.find(
      (d) => d.Name.toLowerCase() == cloudName?.toLowerCase()
    )?.ImagePath;
    if (!image) {
      switch (defaultImage) {
        case 'blueprint':
          image = 'assets/default/default-blueprint.png';
          break;
        case 'brownfieldDiscovery':
          image =
            "this.src='https://www.onlinelogomaker.com/blog/wp-content/uploads/2017/08/Fotolia_128673803_Subscription_Monthly_M.jpg'";
          break;
        default:
          image = 'assets/default/Custom/no-image-available.svg';
          break;
      }
    }
    return image;
  }

  getImageByCloudById(cloudId: any, defaultImage = '') {
    let image = this.CloudData.find((d) => d.Id == cloudId?.toString())?.ImagePath;
    if (!image) {
      switch (defaultImage) {
        case 'security':
          break;
        default:
          image = 'assets/default/Custom/no-image-available.svg';
          break;
      }
    }
    return image;
  }

  getDefaultImageByCloud(cloudName, pageName = '') {
    let image = '';
    switch (cloudName) {
      case 'Azure':
        image =
          pageName == 'inventory'
            ? 'assets/default/Inventory/Inventory-azure.svg'
            : 'assets/default/Blueprint/blueprint-azure.svg';
        break;
      case 'AWS':
        image =
          pageName == 'inventory'
            ? 'assets/default/Inventory/Inventory-aws.svg'
            : 'assets/default/Blueprint/blueprint-aws.svg';
        break;
      case 'GCP':
        image =
          pageName == 'inventory'
            ? 'assets/default/Inventory/Inventory-gcp.svg'
            : 'assets/default/Blueprint/blueprint-gcp.svg';
        break;
      case 'OCI':
        image =
          pageName == 'inventory'
            ? 'assets/default/Inventory/Inventory-oracle.svg'
            : 'assets/default/Blueprint/blueprint-oracle.svg';
        break;
      default:
        image =
          pageName == 'inventory'
            ? 'assets/default/Inventory/default-inventory.svg'
            : 'assets/default/Blueprint/default-blueprint.svg';
        break;
    }
    return image;
  }

  getCollectionImage(collection) {
    if (collection && collection.CollectionAttributeValues) {
      let image = collection.CollectionAttributeValues.find((x) => x.Name.toLowerCase() == 'image');
      if (image) {
        return image.Value;
      } else {
        return 'assets/default/Custom/no-image-available.svg';
      }
    }
  }
}
